module.exports = __webpack_public_path__ + "static/MT_Process-06.cf2d3ae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-icons/MT_Process-06.png
// module id = 1503
// module chunks = 214286880276331